import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ProjectionEssentialSpends } from './ProjectionEssentialSpends';
import { ProjectionsAlert } from './ProjectionsAlert';
import SwipeableViews from 'react-swipeable-views';
import bindKeyboard from 'react-swipeable-views/lib/bindKeyboard';
import { ProjectionMobileEarnings } from './ProjectionMobileEarnings';
import { ProjectionSettingsCommitments } from './ProjectionSettingsCommitments';
import { BasicModal } from '../../../common/modals/BasicModal';
import LoaderComponent from '../../../common/LoaderComponent';
import FinancialStoriesModal from '../../tag/FinancialStoriesModal';
import FinancialStoriesActionCreator from '../../../../actions/FinancialStoriesActionCreator';
import InternetBankingActions from '../../../../actions/InternetBankingActions';
import ProjectionMobPagination from './ProjectionMobPagination';
const AutoPlaySwipeableViews = bindKeyboard(SwipeableViews);
let earningHeading = 'Check your earnings and highlight to include';
let commitmentsHeader1 = 'Your Direct Debits are included in your Projections';
let commitmentsHeader2 =
  'Your Standing Orders are included in your Projections';
let essentailHeader =
  "Select the tags you regularly spend money on and they'll be included in your Projections";
let alertsHeader =
  "Tell us how much you need left in your account, we'll alert you when you fall below that limit";

/**
 * @todo
 * The quality of this component is poor.
 * Future improvement work should be done to increase the health of the overall
 * codebase.
 */
class ProjectionMobileSettings extends Component {
  constructor(props) {
    super(props);

    this.handleSelect = this.handleSelect.bind(this);
    this.getEarnings = this.getEarnings.bind(this);
    this.getEssentialSpends = this.getEssentialSpends.bind(this);
    this.getAlertsComponent = this.getAlertsComponent.bind(this);
    this.getProjectionCommitments = this.getProjectionCommitments.bind(this);
    this.backPopup = this.backPopup.bind(this);
    this.getHeadingTitle = this.getHeadingTitle.bind(this);
    this.getDescription = this.getDescription.bind(this);
    this.getHeader = this.getHeader.bind(this);
    this.popupBack = this.popupBack.bind(this);

    this.state = {
      cancelSetup: false,
      headingTitle: 'Earnings',
      descript: '',
      changeContentFlagCommitments: true,
      activeCss1: 'active',
      activeCss2: '',
    };
  }

  handleSelect(selectedKey) {
    if (selectedKey === 1) {
      this.setState({
        changeContentFlagCommitments: true,
        activeCss1: 'active',
        activeCss2: '',
      });
    } else {
      this.setState({
        changeContentFlagCommitments: false,
        activeCss1: '',
        activeCss2: 'active',
      });
    }
  }

  getEarnings() {
    return (
      <ProjectionMobileEarnings
        data={this.props.data}
        getEarningsId={this.props.getEarningsId}
      />
    );
  }

  getEssentialSpends() {
    return (
      <ProjectionEssentialSpends
        data={this.props.data}
        modifiedUserTag={this.props.modifiedUserTag}
        modifiedTags={this.props.modifiedTags}
      />
    );
  }

  getAlertsComponent() {
    return (
      <ProjectionsAlert
        content={this.props.content}
        changeTheValue={this.props.changeTheValue}
        alertsAmountValue={this.props.alertsAmountValue}
        notificationFlag={this.props.notificationFlag}
        changeTheNotificationFlag={this.props.changeTheNotificationFlag}
        selectDropdown={this.props.selectDropdown}
        dropdownSelection={this.props.dropdownSelection}
        shakeFalse={this.props.shakeFalse}
        shakeamount={this.props.shakeamount}
        shakeamountZero={this.props.shakeamountZero}
        selectedValue={this.props.selectedValue}
      />
    );
  }

  getProjectionCommitments() {
    return (
      <ProjectionSettingsCommitments
        data={this.props.data}
        handleSelect={this.handleSelect}
        changeContentFlagCommitments={this.state.changeContentFlagCommitments}
        activeCss1={this.state.activeCss1}
        activeCss2={this.state.activeCss2}
      />
    );
  }

  backPopup() {
    this.setState({
      cancelSetup: true,
    });
  }

  getHeadingTitle(ind) {
    const slideText = [
      'Earnings',
      'Commitments',
      'Essential Spending',
      'Alerts',
    ];
    return slideText[ind];
  }

  getDescription(ind) {
    if (ind === 0) {
      if (this.props.data !== undefined) {
        if (this.props.data.earnings !== undefined) {
          if (this.props.data.earnings.length === 0) {
            return 'You have no earnings';
          } else {
            return earningHeading;
          }
        } else {
          return earningHeading;
        }
      } else {
        return earningHeading;
      }
    } else if (ind === 1) {
      if (this.state.changeContentFlagCommitments) {
        if (this.props.data !== undefined) {
          if (this.props.data.commitments !== undefined) {
            if (this.props.data.commitments.direct_debits !== undefined) {
              if (this.props.data.commitments.direct_debits.length > 0) {
                return commitmentsHeader1;
              } else {
                return 'You have no Direct Debits';
              }
            } else {
              return commitmentsHeader1;
            }
          } else {
            return commitmentsHeader1;
          }
        } else {
          return commitmentsHeader1;
        }
      } else {
        if (this.props.data !== undefined) {
          if (this.props.data.commitments !== undefined) {
            if (this.props.data.commitments.standing_orders !== undefined) {
              if (this.props.data.commitments.standing_orders.length > 0) {
                return commitmentsHeader2;
              } else {
                return 'You have no Standing Orders';
              }
            } else {
              return commitmentsHeader2;
            }
          } else {
            return commitmentsHeader2;
          }
        } else {
          return commitmentsHeader2;
        }
      }
    } else if (ind === 2) {
      return essentailHeader;
    } else if (ind === 3) {
      return alertsHeader;
    }
  }

  getHeader() {
    return (
      <div className="row no-gutters projection-header">
        <div className="col-xs-3">
          {this.props.cancelButtonFlag ? (
            <button
              className="page-back white"
              onClick={this.props._cancel_button}
              disabled={this.props.onLoad}
            >
              <span className="icon icon-page-back" />
              {this.props.content.back}
            </button>
          ) : (
            <button
              className="page-back white"
              onClick={this.props.doneClicked}
            >
              <span className="icon icon-page-back" />
              {this.props.content.back}
            </button>
          )}
        </div>
        <div className="col-xs-6 text-center">
          <h5>
            {this.props.index >= 0
              ? this.getHeadingTitle(this.props.index)
              : ''}
          </h5>
        </div>
        <div className="col-xs-3 text-right">
          {this.props.cancelButtonFlag ? (
            <button
              className="settings-action"
              onClick={this.props._opt_out_of_projections}
            >
              <span className="icon icon-opt-out" />
            </button>
          ) : (
            ''
          )}
          <button
            className="settings-action"
            onClick={this.props.doneProjectionSettings}
          >
            <span className="icon icon-confirm" />
          </button>
        </div>
        <ProjectionMobPagination
          dots={4}
          index={this.props.index}
          onChangeIndex={this.props.handleChangeIndex}
        />
        <p>
          {this.props.index >= 0 ? this.getDescription(this.props.index) : ''}
        </p>
      </div>
    );
  }

  popupBack() {
    FinancialStoriesActionCreator.handleUpdateFSTileClick();
    InternetBankingActions.navigateToWebTask('WEB-OPEN-FINANCIAL_STORIES');
  }

  render() {
    if (this.props.data.length === 0) {
      return <LoaderComponent type="large" />;
    } else {
      return (
        <div className="projection-setting">
          {this.getHeader()}
          <AutoPlaySwipeableViews
            index={this.props.index}
            onChangeIndex={this.props.handleChangeIndex}
            className="projection-slides"
          >
            <div className="projection-settings-top page-1">
              {this.getEarnings()}
            </div>
            <div className="projection-settings-top page-2">
              {this.getProjectionCommitments()}
            </div>
            <div className="projection-settings-top page-3">
              {this.getEssentialSpends()}
            </div>
            <div className="projection-settings-top page-4">
              {this.getAlertsComponent()}
            </div>
          </AutoPlaySwipeableViews>
          {this.props.optOutFlag ? (
            <FinancialStoriesModal
              header={
                this.props.content.projectionOptOutOfProjectionsPopupHeader
              }
              content={
                this.props.content.projectionOptOutOfProjectionsPopupContent
              }
              confirmCancel={this.props.optOutFlag}
              yesButton
              cancelButton
              cancelText={
                this.props.content
                  .projectionLeaveProjectionsSetupPopupCancelButton
              }
              onClickDeleteTag={this.props.onclickCancelForOptOut}
              yesText={
                this.props.content
                  .projectionOptOutOfProjectionsPopupOptOutButton
              }
            />
          ) : null}
          {this.props.cancelFlag ? (
            <FinancialStoriesModal
              header={
                this.props.content.projectionLeaveProjectionsSetupPopupHeader
              }
              content={
                this.props.content.projectionLeaveProjectionsSetupPopupContent
              }
              confirmCancel={this.props.cancelFlag}
              yesButton
              cancelButton
              cancelText={
                this.props.content
                  .projectionLeaveProjectionsSetupPopupCancelButton
              }
              onClickDeleteTag={this.props.onclickLeaveSetup}
              yesText={
                this.props.content
                  .projectionLeaveProjectionsSetupPopupLeaveSetupButton
              }
            />
          ) : null}
          {this.props.dLeaveSetup ? (
            <FinancialStoriesModal
              header={
                this.props.content.projectionLeaveProjectionsSetupPopupHeader
              }
              content={
                this.props.content.projectionLeaveProjectionsSetupPopupContent
              }
              confirmCancel={this.props.dLeaveSetup}
              yesButton
              cancelButton
              cancelText={
                this.props.content
                  .projectionLeaveProjectionsSetupPopupCancelButton
              }
              onClickDeleteTag={this.props.optoutDemo}
              yesText={
                this.props.content
                  .projectionLeaveProjectionsSetupPopupLeaveSetupButton
              }
            />
          ) : null}
          {this.props.putProjectionPreferenceErrorHandlingFlag ? (
            <FinancialStoriesModal
              header={this.props.putProjectionMessage.error.quoteId}
              content={this.props.putProjectionMessage.error.message}
              confirmCancel={
                this.props.putProjectionPreferenceErrorHandlingFlag
              }
              cancelButton
              cancelText="Ok"
              onClickDeleteTag={this.props.clearPopupForPutProjectionsError}
            />
          ) : (
            ''
          )}
          {this.props.crunch ? (
            <BasicModal>
              <div className="modalb msg-popup single-msg">
                <div className="modalb-contanier">
                  <h3>{this.props.content.projectedCrunchingHeader1}</h3>
                  <p>{this.props.content.projectedCrunchingHeader2}</p>
                </div>
                <div className="modalb-footer">
                  <button
                    className="c-btn c-btn--default"
                    onClick={this.props.popupBack}
                  >
                    {this.props.content.ok}
                  </button>
                </div>
              </div>
            </BasicModal>
          ) : null}
        </div>
      );
    }
  }
}

ProjectionMobileSettings.propTypes = {
  data: PropTypes.object,
  modifiedTags: PropTypes.func,
  modifiedUserTag: PropTypes.func,
};

export { ProjectionMobileSettings };
